module.exports = __webpack_public_path__ + "img/42.7.Chla.6220de34.png";